<template>
  <CartInfoCard
    :infoValue="value"
    :text="text"
    :subtitle="subtitle"
    :hideEdit="true"
    icon="$editcalendar"
    :editable="editable"
    @edit="edit"
  />
</template>
<script>
import CartInfoCard from "./CartInfoCard";
export default {
  name: "CartInfoTimeslotCard",
  props: {
    shippingAddress: { type: Object, required: true },
    timeslot: { type: Object, required: true },
    editable: { type: Boolean, default: false }
  },
  components: { CartInfoCard },
  computed: {
    text() {
      return this.$t(
        "navbar.address." +
          this.shippingAddress.addressTypeId +
          ".timeslotButtonTitle"
      );
    },
    subtitle() {
      return this.$t("navbar.timeslotCardSubtitle");
    },
    value() {
      if (this.timeslot) {
        let date = this.$dayjs(this.timeslot.date);
        return (
          "Da " +
          date.format("ddd D MMMM") +
          " nella fascia oraria " +
          this.$dayjs(this.timeslot.beginTime, ["h:mm:ss A", "H:mm"]).format(
            "HH:mm"
          ) +
          " - " +
          this.$dayjs(this.timeslot.endTime, ["h:mm:ss A", "H:mm"]).format(
            "HH:mm"
          )
        );
      }
      return this.$t("navbar.noTimeslot");
    }
  },
  methods: {
    edit() {
      if (this.editable) {
        this.$emit("edit");
      }
    }
  }
};
</script>
